import { CheckCircleOutlined, ClockCircleOutlined, CloseCircleOutlined } from "@ant-design/icons";
import { Card, Col, Row, Statistic, Tag, Typography } from "antd";
import type { FC } from "react";

import { Palette } from "../../../../core/styles/palette";
import type { SystemHealthDto } from "../types/Dashboard";
import { formatUptime } from "../utils/formatters";

const { Text } = Typography;

interface SystemHealthCardProps {
    health: SystemHealthDto;
}

/**
 * SystemHealthCard - Displays system health metrics
 */
export const SystemHealthCard: FC<SystemHealthCardProps> = ({ health }) => {
    return (
        <Card title="System Health" style={{ backgroundColor: "#FFFFFF", height: "100%" }}>
            <Row gutter={[16, 16]}>
                <Col span={12}>
                    <Statistic
                        title="System Uptime"
                        value={formatUptime(health.uptimeSeconds)}
                        prefix={<ClockCircleOutlined />}
                        valueStyle={{ color: Palette.HeroGreen, fontSize: 16 }}
                    />
                </Col>
                <Col span={12}>
                    <div>
                        <Text type="secondary" style={{ display: "block", marginBottom: 8 }}>
                            Database Connection
                        </Text>
                        {health.databaseConnectionHealthy ? (
                            <Tag icon={<CheckCircleOutlined />} color="success">
                                Healthy
                            </Tag>
                        ) : (
                            <Tag icon={<CloseCircleOutlined />} color="error">
                                Unhealthy
                            </Tag>
                        )}
                    </div>
                </Col>
                <Col span={12}>
                    <Statistic title="Active Threads" value={health.threadCount} valueStyle={{ fontSize: 20 }} />
                </Col>
                <Col span={12}>
                    <Statistic title="Total Threads Started" value={health.totalStartedThreadCount} valueStyle={{ fontSize: 20 }} />
                </Col>
            </Row>
        </Card>
    );
};
